module.exports = __webpack_public_path__ + "img/half.27ec0012.jpeg";